const Whymysore =() =>{
    return(
        <>
        <div className="container-fluid py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">Why Visit Mysore?</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center"><li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    Why Mysore
  </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl py-5">
        <div className="container">
            <div className="row g-4">
                <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="fact-card">
                        <div className="fact-number">600+</div>
                        <div className="fact-label">Years of Royal History</div>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="fact-card">
                        <div className="fact-number">12</div>
                        <div className="fact-label">Magnificent Palaces</div>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
                    <div className="fact-card">
                        <div className="fact-number">200+</div>
                        <div className="fact-label">Heritage Buildings</div>
                    </div>
                </div>
                <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
                    <div className="fact-card">
                        <div className="fact-number">4</div>
                        <div className="fact-label">UNESCO Heritage Sites Nearby</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl py-5">
        <div className="container">
            <div className="row g-5">
                <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s" style={{minHeight: "400px"}}>
                    <div className="position-relative h-100">
                        <img className="img-fluid position-absolute w-100 h-100" src="img/mpalace.jpg" alt="Mysore Palace" style={{objectFit: "cover", borderRadius: "10px"}}/>
                    </div>
                </div>
                <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
                    <h6 className="section-title bg-white text-start pe-3" ></h6>
                    <h1 className="mb-4">Welcome to Mysore<span className="heritage-badge">Heritage City</span></h1>
                    <p className="mb-4">Mysore – a quaint little charming city is sure to take you back in history. It’s palaces, open court yards, gardens & heritage buildings vie with modern architecture. Mysore is renowned for it’s sandal, silk, arts, crafts, music & a university of high repute. It has a very conducive climate with no extremities in weather patterns. As one drives into Mysore, one is greeted not by polluting & monstrous concrete factories but undulating fields of greenery basking in the cool breeze & warm sunshine. Rich in flora & fauna, Mysore is close to abundant wildlife & nature. Very much a pensioners paradise, Mysore holds the promise of natural bliss minus pollution, congestion & traffic jams for a long time to come. Above all Mysore ‘s proximity to Bangalore (just 140 km), the ongoing modernization of the Mysore airport and the proposed 4-lane expressway and doubling of Railway track between Bangalore & Mysore makes it a very rational choice to set up home. IT majors like Infosys, L&T, Wipro have set up their bases at Mysore.</p>
                    
                </div>
                <div className="row g-5">
  <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
    <h2 className="mb-2">Location and Surroundings</h2>
    <p className="mt-0">Mysore city is at 770 m above sea level and 140 kms from Bangalore. Also known as the city of palaces. Mysore retains a quint charm, that never fails to enchant. Mysore is known as a retired person’s paradise and surrounded by palaces, mysore zoo, Krishna Raja Sagar dam/ Brindavan gardens, Chamundi Hills, Kukkarahalli Lake, Karanji lake, Linganbudhi lake, kaveri, kabini etc.,

    </p>
  </div>
</div>
<div className="row g-5">
  <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
    <h2 className="mb-2">Educational Institutions</h2>
    <p className="mt-0">The reputed Mysore university and a range of educational institutions like JSS, Teresian college attract students from the nearby districts.       
    </p>
  </div>
</div>
<div className="row g-5">
  <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
    <h2 className="mb-2">Economy and Employment</h2>
    <p className="mt-0">In the recent past mysore has become a popular choice as the tier II destination among IT and ITes major like Infosys, Wipro, Target corporation, Patni Computers etc Other recognized companies like Vikrant Tyres, K R mills ( Atlantic Mills ), L& T, BEML and Silk factory.      
    </p>
  </div>
</div>
<div className="row g-5">
  <div className="col-12 wow fadeInUp" data-wow-delay="0.1s">
    <h2 className="mb-2">Infrastructure Development</h2>
    <p className="mt-0">Bangalore Mysore Express way will reduce travel time to Bangalore and mysore.
Outer ring road connecting the peripheral areas of mysore is under construction
Airport will be operational from 2009
Railway track doubling and electrification by 2009
Mysore is selected for JNNURM project
The only city in Karnataka to have project – Bus Rapid Transit System (BRTS) under JNNURM     
    </p>
  </div>
</div>
 
            </div>
        </div>
    </div>
        </>
    )
}
export default Whymysore;